import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";


import styles from "./Step3.module.scss";
import { capitalize } from 'helpers/utils/utils_general';
import i18n from 'i18n';

const countryOptions = [
    {
      label: i18n.t("store.1")
    },
    {
      label: i18n.t("wine.cellar.1")
    },
    {
      label: i18n.t("central.warehouse")
    },
    {
      label: i18n.t("warehouse.2")
    }
  ]
export class AddBusinessNodeStepThree extends React.Component {
  render() {
    const { businessnode, handleChange, selectCategory, goBack, handleFinish, error } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>
      <div className={styles["add-businessnode-wizard-step-three-content"]}>
        <div className={styles["add-businessnode-wizard-step-three-field"]} data-automation-id="input-length">
          <MainInput
            label={capitalize(i18n.t("measure_depth")).concat(" (mts)")}
            id={"businessnode-length"}
            name="measure_depth"
            type="number"
            value={businessnode ? businessnode.measure_depth : ''}
            handleChange={handleChange}
            maxLength={100}
            onlyNumbers="true"
            positiveNumbers="true"
            error={error.measure_depth && error.measure_depth}
          />
        </div>
        <div className={styles["add-businessnode-wizard-step-three-field"]} data-automation-id="input-height">
          <MainInput
            label={capitalize(i18n.t("measure_height")).concat(" (mts)")}
            id={"businessnode-height"}
            name="measure_height"
            type="number"
            value={businessnode ? businessnode.measure_height : ''}
            handleChange={handleChange}
            maxLength={100}
            onlyNumbers="true"
            positiveNumbers="true"
            error={error.measure_height && error.measure_height}
          />
        </div>
        <div className={styles["add-businessnode-wizard-step-three-field"]} data-automation-id="input-wide">
          <MainInput
            label={capitalize(i18n.t("measure_width")).concat(" (mts)")}
            id={"businessnode-wide"}
            name="measure_width"
            type="number"
            value={businessnode ? businessnode.measure_width : ''}
            handleChange={handleChange}
            maxLength={100}
            onlyNumbers="true"
            positiveNumbers="true"
            error={error.measure_width && error.measure_width}
          />
        </div>
        <div className={styles["add-businessnode-wizard-step-three-field"]} data-automation-id="input-capacity">
          <MainInput
            label={i18n.t("capacity")}
            id={"businessnode-capacity"}
            name="capacity"
            type="number"
            value={businessnode ? businessnode.capacity : ''}
            handleChange={handleChange}
            maxLength={100}
            onlyNumbers="true"
            positiveNumbers="true"
            error={error.capacity && error.capacity}
          />
        </div>
        <div className={styles["add-businessnode-wizard-step-three-action-wrapper"]}>
          <button type="submit" className={styles["add-businessnode-wizard-step-three-action-button"]}>
            {i18n.t("finish").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-businessnode-wizard-step-three-container"]}>
        <Step title={i18n.t("dimensions").concat(" (", i18n.t("optional", ")"))} content={stepContent} goBackFunc={goBack}></Step>
      </div>
    );
  }
}

export default AddBusinessNodeStepThree;
